import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { StockInEntity } from "./stock-in.entity";
import { StatusEnum } from "@needle-management/shared-models";
import { ReturnStatusEnum } from "@needle-management/shared-models";

@Entity('stock_out')
export class StockOutEntity {

    @PrimaryGeneratedColumn("increment",{name:'id'})
    id:number;

    @Column('date',{
        name:'issued_at',
        nullable:false
    })
    issuedAt:string

    @Column('varchar',{
        name:'issued_by',
        nullable:true
    })
    issuedBy:string

    @Column('varchar',{
        name:'issued_to',
        nullable:true
    })
    issuedTo:string

    @Column('varchar',{
        name:'module_no',
        nullable:true
    })
    moduleNo:string

    @Column('varchar',{
        name:'job_no',
        nullable:true
    })
    jobNo:string

    @Column('varchar',{
        name:'shift',
        nullable:true
    })
    shift:string

    @Column('int',{
        name:'style_id',
        nullable:false
    })
      styleId:number

      @Column('int',{
        name:'stock_id',
        nullable:false
    })
      stockId:number

      @Column('int',{
        name:'request_id',
        nullable:false
    })
    requestId:number

    @Column('decimal', {
        name: 'issued_quantity',
        nullable: false,
        
    })
    issuedQuantity:number;

    @Column({
        type: 'enum',
        enum: ReturnStatusEnum,
        nullable: true,
        name: 'return_status',
      })
      returnStatus: ReturnStatusEnum;
      
    @CreateDateColumn({
        name: "created_at",
        type:"datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length:50
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type:'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length:50
    })
    updatedUser: string | null;


    @VersionColumn({
        default:1,
        name: "version_flag"
    })
    versionFlag: number;

    @ManyToOne(type => StockInEntity, stock => stock.stockOutData,{nullable:false})
    @JoinColumn({name:'stock_id'})
    stockInInfo: StockInEntity
}
